import { Action, ActionCreator } from 'redux'
import { UI_HIDE_COOKIE_BANNER } from './types'

export const uiHideCookieBanner: ActionCreator<Action> = () => ({
  type: UI_HIDE_COOKIE_BANNER,
})
